export enum FBTrackingEvent {
    FTUE_01_SdkInit = 'FTUE_01_SdkInit', // Softgames SDK Initialized (first possible event)
    FTUE_02_LoadingIsCompleted = 'FTUE_02_LoadingIsCompleted', // Connection to Game Backend established
    FTUE_03_GamefieldIsShow = 'FTUE_03_GamefieldIsShow', // Loading 100%
    FTUE_05_FirstCardClear = 'FTUE_05_FirstCardClear', // First Match of Level 1
    FTUE_06_Level01FinishWindowShow = 'FTUE_06_Level01FinishWindowShow', // Level 1 win screen is shown
    FTUE_07_TapOnButtonContinue = 'FTUE_07_TapOnButtonContinue', // User taps on level 1 continue button
    FTUE_10a_Level2PreLevelButtonPlay = 'FTUE_10a_Level2PreLevelButtonPlay', // User tap on level 2 play button (pre level UI)
    FTUE_11_Gamefield2IsShow = 'FTUE_11_Gamefield2IsShow', // Level 2 loads
    FTUE_15_Level02FinishWindowShow = 'FTUE_15_Level02FinishWindowShow', // Level 2 win screen is shown
    FTUE_20a_Level3PreLevelButtonPlay = 'FTUE_20a_Level3PreLevelButtonPlay', // User tap on level 3 play button (pre level UI)
    FTUE_21_Gamefield3IsShow = 'FTUE_21_Gamefield3IsShow', // Level 3 loads
    FTUE_23_Level03FinishWindowShow = 'FTUE_23_Level03FinishWindowShow', // Level 3 win screen is shown
    VideoAdWatchFiveCards = 'VideoAdWatchFiveCards', // Rewarded ad filled at +5 cards
    VideoAdWatchGetCoins = 'VideoAdWatchGetCoins', // Rewarded ad filled at get more coins
    VideoAdWatchWheel = 'VideoAdWatchWheel', // Rewarded ad filled for spinning prize wheel
    VideoAdWatchGetLife = 'VideoAdWatchGetLife', // Rewarded Ad Filled at getting extra life
    VideoAdWatchSkipMission = 'VideoAdWatchSkipMission', // Rewarded Ad Filled for skipping a mission
    VideoAdWatch_3star_present = 'VideoAdWatch_3star_present', // Rewarded Ad filled for opening extra 3-star reward presents
    RewardedAdRequested = 'RewardedAdRequested',
    RewardedAdDisplayed = 'RewardedAdDisplayed',
    VideoAdCannotBeDisplayedFillrate = 'VideoAdCannotBeDisplayedFillrate',
    InterstitialAdRequested = 'InterstitialAdRequested',
    InterstitialAdDisplayed = 'InterstitialAdDisplayed',
    TapOnBuyFiveCards = 'TapOnBuyFiveCards', // Successfully Purchasing +5 cards
    TapOnUndoMove = 'TapOnUndoMove', // Successfully Purchasing Undo Move Booster
    TapOnJokerCard = 'TapOnJokerCard', // Successfully Purchasing Joker Booster
    TapOnBullsEye = 'TapOnBullsEye', // Successfully Purchasing Bullseye Booster
    TapOnTNT = 'TapOnTNT', // Successfully Purchasing TNT Booster
    TapOnShuffle = 'TapOnShuffle', // Successfully Purchasing Shuffle Booster
    BuyLifeCoins = 'BuyLifeCoins', // Successfully Purchasing Life
    three_star_window_show = '3_star_window_show', // User is shown the 3-star reward Window
    three_star_share_success = '3_star_share_success', // User shares 3-star with their friend (tick box on, share via facebook api).
    Bot_show = 'Bot_show', // User Taps on Bot opt-in icon and window is shown.
    Bot_close = 'Bot_close', // User taps on Close button when window is open.
    Bot_accept = 'Bot_accept', // User taps on green "subscribe" button
    Bot_deny = 'Bot_deny', // User taps on "deny" on facebook bot UI window
    Bot_confirm = 'Bot_confirm', // User taps on "Turn on" on facebook bot UI window
    Design_SH_Gift_Show = 'Design_SH_Gift_Show', // User taps on Present icon
    Design_SH_Gift_Claim = 'Design_SH_Gift_Claim', // User confirms context switch (FB UI) and receives coins for gift
    Design_GH_Invite = 'Design_GH_Invite', // User taps on Invite Friends button
    Design_Event_Complete = 'Design_Event_Complete', // User completes a weekly Event
    Win_Invite_Send = 'Win_Invite_Send', // User completes a level and challenge a friend
    Mission_Complete = 'Mission_Complete', // User completes a daily mission NEW
    Life_request = 'Life_request', // User requests a life from their friend
    Life_send = 'Life_send', // User sends a life to their friend
    TapOnWheelLife = 'TapOnWheelLife', // User taps on "Spin the wheel" button on "No Lives" menu

    // More level tracking:
    Level4_GameFieldShow = 'Level4_GameFieldShow',
    Level5_GameFieldShow = 'Level5_GameFieldShow',
    Level6_GameFieldShow = 'Level6_GameFieldShow',
    Level7_GameFieldShow = 'Level7_GameFieldShow',
    Level8_GameFieldShow = 'Level8_GameFieldShow',
    Level9_GameFieldShow = 'Level9_GameFieldShow',
    Level10_GameFieldShow = 'Level10_GameFieldShow',

    Level4_WinScreenShow = 'Level4_WinScreenShow',
    Level5_WinScreenShow = 'Level5_WinScreenShow',
    Level6_WinScreenShow = 'Level6_WinScreenShow',
    Level7_WinScreenShow = 'Level7_WinScreenShow',
    Level8_WinScreenShow = 'Level8_WinScreenShow',
    Level9_WinScreenShow = 'Level9_WinScreenShow',
    Level10_WinScreenShow = 'Level10_WinScreenShow',

    fox_popup_show = 'fox_popup_show', // Tapping on Foxy to collect reward
    ScoreBeatenShare = 'ScoreBeatenShare', // Sharing Friend's score beating feature

    // Progress Restore Tracking SOLI-698
    ProgressRestore_Reward = 'ProgressRestore_Reward', // Triggered 1st time player's progress is restored, and they get the initial reward.
    ProgressRestore_Other = 'ProgressRestore_Other', // Triggered all the following times when a player's progress is restored (they do not get another reward).
    ProgressRestore_Initial = 'ProgressRestore_Initial', // Triggered 1st time player's progress is restored, and they don't get the initial reward.

    Helper_Show = 'Helper_Show', // Helper friend feature appears
    Helper_Accept = 'Helper_Accept', // Players taps accept help on helper icon
    Helper_Confirm = 'Helper_Confirm', // Player confirms context switch and receives cards
    Helper_Entry = 'Helper_Entry', // Friend enters the game via sent custom message

    // XPromo Tracking
    xPromo_Show = 'xPromo_Show', // Show the XPromo in-game UI.
    xPromo_Accept = 'xPromo_Accept', // Tap the "Play Now" button in the in-game UI.
    xPromo_Close = 'xPromo_Close', // Close the in-game UI.
    xPromo_Confirm = 'xPromo_Confirm', // Click "Play" in the Facebook UI.
    xPromo_Deny = 'xPromo_Deny', // Close the Facebook UI.

    // XPromo Incoming
    Entries_xPromo = 'Entries_xPromo',
    XPromo_new_user = 'XPromo_new_user',
    XPromo_old_user = 'XPromo_old_user',

    CreateShortcutShow = 'CreateShortcutShow', // Player sees Shortcut UI window
    CreateShortcutAccept = 'CreateShortcutAccept', // Player taps on "Add" button in UI window
    CreateShortcutConfirm = 'CreateShortcutConfirm', // Player confirms shortcut via Facebook UI prompt
    CreateShortcutClose = 'CreateShortcutClose', // Player closes the short cut window

    // IAP
    Product007_Start = 'Product007_Start',
    Product008_Start = 'Product008_Start',
    Product009_Start = 'Product009_Start',
    Product010_Start = 'Product010_Start',
    Product011_Start = 'Product011_Start',
    Product012_Start = 'Product012_Start',

    Product007_Success = 'Product007_Success',
    Product008_Success = 'Product008_Success',
    Product009_Success = 'Product009_Success',
    Product010_Success = 'Product010_Success',
    Product011_Success = 'Product011_Success',
    Product012_Success = 'Product012_Success',

    Product007_Fail = 'Product007_Fail',
    Product008_Fail = 'Product008_Fail',
    Product009_Fail = 'Product009_Fail',
    Product010_Fail = 'Product010_Fail',
    Product011_Fail = 'Product011_Fail',
    Product012_Fail = 'Product012_Fail',

    Postcard_Share_Show = 'Postcard_Share_Show',
    Postcard_Share_Send = 'Postcard_Share_Send',
    Postcard_Entry = 'Postcard_Entry',

    Prizewheel_Share = 'Prizewheel_Share',
    Prizewheel_Entry = 'Prizewheel_Entry',
    ASOLI_Lvl05_Complete = 'ASOLI_Lvl05_Complete',
    ASOLI_Lvl10_Complete = 'ASOLI_Lvl10_Complete',
    ASOLI_Lvl15_Complete = 'ASOLI_Lvl15_Complete',
    ASOLI_Lvl20_Complete = 'ASOLI_Lvl20_Complete',
    ASOLI_Lvl40_Complete = 'ASOLI_Lvl40_Complete',
    ASOLI_Lvl80_Complete = 'ASOLI_Lvl80_Complete',
    ASOLI_Lvl160_Complete = 'ASOLI_Lvl160_Complete',
    ASOLI_Lvl240_Complete = 'ASOLI_Lvl240_Complete',
    ASOLI_Lvl320_Complete = 'ASOLI_Lvl320_Complete',
    ASOLI_Lvl400_Complete = 'ASOLI_Lvl400_Complete',
    ASOLI_Lvl480_Complete = 'ASOLI_Lvl480_Complete',
    ASOLI_Lvl560_Complete = 'ASOLI_Lvl560_Complete',
    ASOLI_UserEnter_Austria = 'ASOLI_UserEnter_Austria',
    ASOLI_UserEnter_Bali = 'ASOLI_UserEnter_Bali',
    ASOLI_UserEnter_Italy = 'ASOLI_UserEnter_Italy',
    ASOLI_UserEnter_Japan = 'ASOLI_UserEnter_Japan',
    ASOLI_UserEnter_Iceland = 'ASOLI_UserEnter_Iceland',
    ASOLI_UserEnter_Australia = 'ASOLI_UserEnter_Australia',
    ASOLI_UserEnter_Egypt = 'ASOLI_UserEnter_Egypt',
    ASOLI_UserEnter_Arizona = 'ASOLI_UserEnter_Arizona',
    ASOLI_UserEnter_Paris = 'ASOLI_UserEnter_Paris',
    ASOLI_UserEnter_Tanzania = 'ASOLI_UserEnter_Tanzania',
    ASOLI_UserEnter_Berlin = 'ASOLI_UserEnter_Berlin',
    ASOLI_UserEnter_Cambodia = 'ASOLI_UserEnter_Cambodia',
    ASOLI_UserEnter_England = 'ASOLI_UserEnter_England',
    ASOLI_UserEnter_Canada = 'ASOLI_UserEnter_Canada',
    ASOLI_UserEnter_Brazil = 'ASOLI_UserEnter_Brazil',
    ASOLI_UserEnter_Russia = 'ASOLI_UserEnter_Russia',
}
